import {BaseCrudService} from "./baseCrudService";
import {CapDto} from "../dto/cap-dto";

class CapService extends BaseCrudService<CapDto> {
  constructor() {
    super("/api/v1/caps", true);
  }
}

export const capService = new CapService();